module.exports = __webpack_public_path__ + "static/07-64e2a24e485532b57f47fd682576cbb3.jpg";